import _classCallCheck from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/createClass.js";

//
//  This file is to replicate the expand and collapse for sources and footnotes to function similar to the front-end-metrics npm package
//  https://dev.azure.com/USAFacts/frontend-library-metrics/_git/frontend-library-metrics?path=%2Fcomponents%2FSourcesAndFootnotes%2FTextExpander.js
var SourcesAndFootnotesExpander = /*#__PURE__*/function () {
  function SourcesAndFootnotesExpander(node) {
    _classCallCheck(this, SourcesAndFootnotesExpander);

    this.node = node;
    this.content = node.querySelector("[data-text-expander-content]");
    this.summary = node.querySelector("[data-text-expander-summary]");
    this.seeLess = node.querySelector("[data-text-see-less]");
    this.seeMore = node.querySelector("[data-text-see-more]");
    this.bindEvents();
  }

  _createClass(SourcesAndFootnotesExpander, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.seeMore.addEventListener("click", function () {
        _this.expand();
      });
      this.seeLess.addEventListener("click", function () {
        _this.collapse();
      });
    }
  }, {
    key: "expand",
    value: function expand() {
      this.show(this.content);
      this.hide(this.summary);
    }
  }, {
    key: "collapse",
    value: function collapse() {
      this.hide(this.content);
      this.show(this.summary);
    }
  }, {
    key: "show",
    value: function show(el) {
      el.style.display = "flex";
      el.setAttribute("aria-expanded", "true");
    }
  }, {
    key: "hide",
    value: function hide(el) {
      el.style.display = "none";
      el.setAttribute("aria-expanded", "false");
    }
  }]);

  return SourcesAndFootnotesExpander;
}();

export default function initSourcesAndFootnotesExpander() {
  var expanders = document.querySelectorAll("[data-text-expander]");

  if (expanders) {
    expanders.forEach(function (el) {
      return new SourcesAndFootnotesExpander(el);
    });
  }
}